import { AsyncPipe, NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { FormlyModule } from '@ngx-formly/core';
import { ParentAccount } from '@app/modules/fund-management/accounts/models/accounts';
import { FormlyAutocompleteTypeComponent } from './autocomplete-type.component';

@Component({
    selector: 'formly-account-autocomplete-type',
    template: `
		<input
			matInput
			[matAutocomplete]="auto"
			[formControl]="formControl"
			[formlyAttributes]="field"
			[placeholder]="to.placeholder"
			[readonly]="to.readonly"
			[errorStateMatcher]="errorStateMatcher"
			(blur)="onBlur()"
			(keydown)="onKeyDown($event)"
		/>
		<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionChanged($event.option)" [displayWith]="displayFn">
			<mat-option *ngFor="let option of filter | async" [value]="option" [id]="displayFn(option)">
				{{ option.AccountNumber }}
			</mat-option>
		</mat-autocomplete>
	`,
    standalone: true,
    imports: [
        MatInputModule,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyModule,
        NgFor,
        MatOptionModule,
        AsyncPipe,
    ],
})
export class FormlyAccountAutocompleteTypeComponent extends FormlyAutocompleteTypeComponent {
	displayFn(account: ParentAccount): string {
		return account.AccountNumber;
	}
}
